import LiquidGlass from "./liquid-glass";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  radius?: string;
  isActive?: boolean;
}

export default function Button({
  children,
  className = "",
  radius,
  isActive = false,
  ...props
}: ButtonProps) {
  return (
    <LiquidGlass
      as="button"
      radius={radius}
      disabled={!isActive}
      className={`select-none px-8 py-3.5 border-0 cursor-pointer
                  transition-all duration-250 ease-out
                  hover:-translate-y-0.5
                  active:translate-y-0 active:scale-[0.98]
                  ${className}`}
      {...props}
    >
      {children}
    </LiquidGlass>
  );
}
